var global = require('../internals/global');
var bind = require('../internals/bind-context');
var call = Function.call;

module.exports = function (CONSTRUCTOR, METHOD, length) {
  return bind(call, global[CONSTRUCTOR].prototype[METHOD], length);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@firebase/polyfill/node_modules/core-js/internals/entry-unbind.js
// module id = 209
// module chunks = 0